module.exports = __webpack_public_path__ + "img/Logo-resize.b32515a8.svg";